import React from 'react';
import { ButtonBase, ButtonBaseProps } from '@material-ui/core';

import { colors, useGridButtonStyles } from './GridButtonSizeProvider';

type GridButtonProps = ButtonBaseProps & {
  btnColor?: keyof typeof colors;
};

function GridButton({ btnColor, className, ...rest }: GridButtonProps) {
  const { classes } = useGridButtonStyles();
  const gridButtonClass = classes?.gridButton ?? '';
  const buttonColorClass = classes?.[`gridButton-${btnColor}`] ?? '';
  return (
    <ButtonBase
      disableRipple
      disableTouchRipple
      className={`${gridButtonClass} ${buttonColorClass} ${className}`}
      {...rest}
    />
  );
}

export default React.memo(GridButton);
